import React, { useState, useCallback } from "react";
import { Button } from "@design-system/Button/Button";
import { useTeamViewStore } from "@hooks/view/useTeamViewStore";
import { ORGANIZATION_USER_CACHE_KEYS } from "@hooks/useOrganizationUserCache";
import interfaceStyles from "@components/mainInterface/MainInterface.module.scss";
import { useCanPerformOrganizationAction } from "@hooks/permissions/organization/useCanPerformOrganizationAction";
import { OrganizationAction } from "@common/userOrganizationRoles";
import { useActiveOrganization } from "@hooks/useActiveOrganization";
import { useOverlays } from "contexts/OverlayContext";
import { TablePageHeader } from "../../pageHeader/TablePageHeader";
import { TeamView } from "./views/TeamView";

export const TeamPage: React.FC = () => {
    const [search, setSearch] = useState("");
    const canAddTeam = useCanPerformOrganizationAction(
        OrganizationAction.INVITE_TEAM_MEMBER,
    );
    const activeOrganization = useActiveOrganization();
    const { openOverlay } = useOverlays();

    const { view, setView } = useTeamViewStore({
        cacheKey: ORGANIZATION_USER_CACHE_KEYS.TEAM_PAGE_VIEW_CACHE_KEY,
    });

    const handleSearchClear = useCallback(() => {
        setSearch("");
    }, []);

    return (
        <article className={interfaceStyles.fullHeightContent}>
            <TablePageHeader
                search={search}
                onSearchChange={setSearch}
                isFullPage
            >
                {canAddTeam && (
                    <Button
                        variant="primary"
                        size="md"
                        onClick={() => {
                            if (!activeOrganization) {
                                return;
                            }
                            openOverlay("organizationAddTeamMember", {
                                organization: activeOrganization,
                            });
                        }}
                    >
                        Add member
                    </Button>
                )}
            </TablePageHeader>

            <TeamView
                view={view}
                search={search}
                onViewChange={setView}
                onSearchClear={handleSearchClear}
            />
        </article>
    );
};
